<script setup>
definePageMeta({
  layout: 'sign-in',
})

const clerkThemeStore = useClerkThemeStore()
</script>

<template>
  <SignIn
    sign-up-url="/sign-up"
    transferable
    with-sign-up
    v-bind="clerkThemeStore"
  />
</template>
